export default class OrganizationAppContact {
  constructor(API) {
    this.api = API;
  }
  /* CRUD */
  async getOrganizationAppContact(orgID, contactID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/' + orgID + '/app/contact/' + contactID;
    return await req.exec();
  }
  async removeOrganizationAppContact(orgID, contactID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/organization/' + orgID + '/app/contact/' + contactID;
    return await req.exec();
  }
  async createOrganizationAppContact(orgID, contactID, contactObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organization/' + orgID + '/app/contact/' + contactID;
    // req.body = { ...contactObj }; -- no body for now
    return await req.exec();
  }
  /* List */
  async getAllOrganizationAppContacts(orgID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/organization/${orgID}/app/appContacts`;
    return await req.exec();
  }
  async getAllOrganizationContacts(orgID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/organization/${orgID}/appContacts`;
    return await req.exec();
  }
  async getAllContactOrganizationApps(contactID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/contact/${contactID}/appContacts`;
    return await req.exec();
  }
}
